module.exports = "/assets/data/e77ec8e52566baaeaac79eb0c5b6cd1d-WN2.data.json";